import { Auth as aws } from 'aws-amplify'
import { useAuthStore } from 'shared/store/authSlice'

export type SignInOptions = {
  user: string
  password: string
}

export enum AuthErrors {
  MFA_REQUIRED = 'MFA_REQUIRED'
}

export const signIn = async (params: SignInOptions) => {
  const { logIn } = useAuthStore.getState()
  const { user: username, password } = params
  const user = await aws.signIn({ username, password })
  if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
    return [AuthErrors.MFA_REQUIRED, user]
  } else {
    logIn()
  }
}
